export default __webpack_public_path__ + "static/media/EC.aaf54ce8.svg";